import { useEffect, useState } from 'react';
import { BlechconCustomerConfigurationFrontend } from '../../blechcon';
import { toast } from 'react-toastify';
import { localized } from '../../config/localization';
import { getBlechconConfiguration } from '../../services/api/blechconApi';

export function useConfiguration(): BlechconCustomerConfigurationFrontend | null {
  const [configuration, setConfiguration] = useState<BlechconCustomerConfigurationFrontend | null>(null);

  useEffect(() => {
    getBlechconConfiguration()
      .then((response: BlechconCustomerConfigurationFrontend) => {
        setConfiguration(response);
      })
      .catch((error) => {
        console.error('Error in useConfiguration', error);
        toast.error(localized.CONFIGURATION_LOAD_ERROR);
      });
  }, []);

  return configuration;
}
